const projectsModel = {
	projects: {}
}

export default projectsModel
